<template>
    <v-dialog
        v-model='dialog'
        class='mainDialog'
        fullscreen
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                x-small
                icon
                @click='dialog=true; runVids();'
            >
              <v-icon color="orange">mdi-arrow-expand</v-icon>
            </v-btn>
        </template>
        <v-card tile color='#333333'>
            <v-app-bar color='#1f1f1f' flat absolute>
                <v-btn
                    icon
                    dark
                    @click="updateParent(); dialog = false"
                >
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title class='pr-10'>
                    <v-row>
                        <v-col v-if="session.state === 'Established' && session.remoteIdentity.displayName">
                            <h4 style='color:white;'><nobr>{{session.remoteIdentity.displayName}}</nobr></h4>
                        </v-col>
                        <v-col v-if="session.state === 'Established'">
                            <h4 style='color:white;'><nobr>{{formatNum(session.remoteIdentity.uri.user)}}</nobr></h4>
                        </v-col>
                        <v-col v-if="session.state === 'Established' && $parent.hold">
                            <h4 style='color:white;' class="PULSE"><nobr>(On Hold)</nobr></h4>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-app-bar>
            <v-container fluid style="height: 87vh; padding-right:326px; padding-top:72px;">
                <v-row no-gutters justify='center'>
                  <div :class='fullscreen ? "fullscreen" : ""'>
                    <v-row justify='center' class='mx-0'>
                      <canvas id='maxMedia'></canvas>
                      <v-btn icon large @click='fullscreen=!fullscreen' :style='fullscreen ? "position:absolute; right:5px; bottom:5px;" : "position:absoolute; bottom:5px; right:335px;"'>
                        <v-icon v-if='fullscreen' color='white'>mdi-fullscreen-exit</v-icon>
                        <v-icon v-else color='white'>mdi-fullscreen</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-row>
            </v-container>
            <v-navigation-drawer elevation='0' width='328' color='#292929' v-if='dialog' absolute right permanent>
                <v-toolbar color='#1f1f1f' flat class='mb-1'></v-toolbar>
                <v-row justify='center'>
                    <canvas style='border:2px orange solid;' id="maxLocal"></canvas>
                </v-row>
                <v-row no-gutters justify='center'>

                </v-row>
                <template v-slot:append>
                  <div class="pa-2">
                    <v-card color="#1f1f1f" elevation="0" height='100' class='controls'>
                      <v-card-actions v-if='session.state === "Established" && showNumPad == true'><numpad></numpad></v-card-actions>
                      <v-card-actions class='ma-0 pa-0'>
                          <v-btn 
                          @click='$sip.bye()' 
                          dark
                          color="red" 
                          fab
                          class='ml-1'>
                              <v-icon>mdi-phone-hangup-outline</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <media-input-selector></media-input-selector>
                          <v-card elevation='0' color="rgb(0,0,0,0)">
                              <v-container ma-0 py-0 v-if="session.state == 'Established'">
                                  <v-row class="mb-1" no-gutters align='center'>
                                      <v-col class='mr-1'>
                                          <v-tooltip left>
                                              <template v-slot:activator="{ on, attrs }">
                                                  <div>
                                                  <v-btn 
                                                      v-if="session.state == 'Established' && !session.localVideo" 
                                                      @click='addStream(); attachMedia();'
                                                      color="blue" 
                                                      dark
                                                      fab
                                                      small
                                                      v-bind="attrs"
                                                      v-on="on">
                                                      <v-icon>mdi-video</v-icon>
                                                  </v-btn>
                                                  <v-btn 
                                                      v-if="session.state == 'Established' && session.localVideo" 
                                                      @click='addStream(); attachMedia();'
                                                      color="blue" 
                                                      dark
                                                      fab
                                                      small
                                                      v-bind="attrs"
                                                      v-on="on">
                                                      <v-icon>mdi-video-off</v-icon>
                                                  </v-btn>
                                                  </div>
                                              </template>
                                              <span v-if="!session.localVideo">Camera On</span>
                                              <span v-if="session.localVideo">Camera Off</span>
                                          </v-tooltip>
                                      </v-col>
                                      <v-col class='mr-1'>
                                          <v-tooltip top>
                                          <template v-slot:activator="{ on, attrs }">
                                              <div>
                                              <v-btn 
                                                  v-if="session.state == 'Established' && (!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)" 
                                                  @click='myChannel.id !== null ? muteCaller(myChannel) : $sip.mute(true)' 
                                                  color="teal" 
                                                  dark
                                                  fab
                                                  small
                                                  v-bind="attrs"
                                                  v-on="on">
                                                  <v-icon>mdi-microphone</v-icon>
                                              </v-btn>
                                              <v-btn 
                                                  v-if="session.state == 'Established' && (session.isMuted && !myChannel.id) || (myChannel.muted && myChannel.id)" 
                                                  @click='myChannel.id !== null ? unmuteCaller(myChannel) : $sip.mute(false)' 
                                                  color="teal" 
                                                  dark
                                                  fab
                                                  small
                                                  v-bind="attrs"
                                                  v-on="on">
                                                  <v-icon>mdi-microphone-off</v-icon>
                                              </v-btn>
                                              </div>
                                          </template>
                                          <span v-if="!session.isMuted">Mute</span>
                                          <span v-if="session.isMuted">Un-Mute</span>
                                          </v-tooltip>
                                      </v-col>
                                      <v-col>
                                          <v-tooltip right>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-btn 
                                              v-if="'Established' === session.state" 
                                              @click="showNumPad = !showNumPad"
                                              color="blue"
                                              fab
                                              small
                                              v-bind="attrs"
                                              v-on="on">
                                              <v-icon>mdi-dialpad</v-icon>
                                              </v-btn>
                                          </template>
                                          <span>Dialpad</span>
                                          </v-tooltip>
                                      </v-col>
                                  </v-row>
                                  <v-row no-gutters align='center'>
                                      <v-col class='mr-1'>
                                          <v-tooltip left>
                                          <template v-slot:activator="{ on, attrs }">
                                              <div>
                                              <v-btn 
                                                  v-if="session.state == 'Established'" 
                                                  @click='addDisplay(); attachMedia();'
                                                  color="teal" 
                                                  dark
                                                  fab
                                                  small
                                                  v-bind="attrs"
                                                  v-on="on">
                                                  <v-icon>mdi-monitor-share</v-icon>
                                              </v-btn>
                                              </div>
                                          </template>
                                          <span>Share Screen</span>
                                          </v-tooltip>
                                      </v-col>
                                      <v-col class='mr-1'>
                                          <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <div>
                                              <v-btn 
                                                  v-if="session.state == 'Established' && !session.isHeld" 
                                                  @click='$sip.hold(true); hold=true' 
                                                  color="blue" 
                                                  dark
                                                  fab
                                                  small
                                                  v-bind="attrs"
                                                  v-on="on">
                                                  <v-icon>mdi-phone-paused</v-icon>
                                              </v-btn>
                                              <v-btn 
                                                  v-if="session.state == 'Established' && session.isHeld" 
                                                  @click='$sip.hold(false); hold=false' 
                                                  color="blue" 
                                                  fab
                                                  small
                                                  v-bind="attrs"
                                                  v-on="on">
                                                  <v-icon>mdi-phone-in-talk</v-icon>
                                              </v-btn>
                                              </div>
                                          </template>
                                          <span v-if="!session.isHeld">Hold</span>
                                          <span v-if="session.isHeld">Un-Hold</span>
                                          </v-tooltip>
                                      </v-col>
                                      <v-col>
                                          <v-tooltip right>
                                          <template v-slot:activator="{ on, attrs }">
                                              <div 
                                                  v-bind="attrs"
                                                  v-on="on">
                                              <transfer-menu></transfer-menu>
                                              </div>
                                          </template>
                                          <span>Transfer Call</span>
                                          </v-tooltip>
                                      </v-col>
                                  </v-row>
                              </v-container>
                          </v-card>
                      </v-card-actions>
                    </v-card>
                  </div>
                </template>
            </v-navigation-drawer>
        </v-card>
    </v-dialog>
</template>
<script >
import { mapState } from "vuex";
import { Invitation } from 'sip.js';
import MediaInputSelector from '../components/media-input-selector.vue';
import TransferMenu from '../components/TransferMenu.vue'
import NumPad from '../components/numpad.vue'
import ConferenceCommon from '../mixins/conferencecommon';
import Common from '../mixins/common';

export default {
  data: () =>({
    hold: false,
    menu: false,
    transferNum: null,
    showNumPad: false,
    dialog: false,
    fullscreen: false,
  }),
  mounted() { 
    this.attachMedia();
  },
  updated() { this.attachMedia() },
  computed: {
    ...mapState(["lineKeys"]),
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    showMedia: {
      get() { 
        if (!this.session) return false;
        if (this.session.mediaElement) return this.session.mediaElement.srcObject.getVideoTracks().length != 0
        else return false;  
      }
    },
    numberCalling: {
      // This will show the number on the dialpad, but will not always match to the session
      // TODO: get this from the session instead.
      //
      // (will matter more when there are multiple sessions)
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    media: {
      get: function() {
        if (this.session) {
          return this.session.mediaElement;
        }
        return null;
      }
    },
    localVideo: {
      get: function() {
        if (this.session) {
          return this.session.localVideo;
        }
        return null;
      }
    },
    isDev: {
      get() { return process.env.NODE_ENV!=='production' }
    },
    myChannel: {
      get: function() { 
        return this.$store.getters['conference/myChannel']; 
      },
    },
  },
  components: {
    'media-input-selector': MediaInputSelector,
    'transfer-menu': TransferMenu,
    'numpad': NumPad,
  },
  mixins: [ConferenceCommon, Common],
  methods: {
    runVids(){
      this.$nextTick(function () {
        try {
          this.updateLocalVid();
        }
        catch(err) {}
        try {
          this.updateMediaVid();
        }
        catch(err) {}
      })
    },
    updateLocalVid(){
      var v = document.getElementById('minLocal'); 
      var canvas = document.getElementById('maxLocal');
      if (canvas === null) return;
      var c = canvas.getContext('2d');
      var w = 317;
      var h = v.videoHeight*(w/v.videoWidth);
      canvas.width = w;
      canvas.height = h;
      if (v.paused || v.ended) return false;
      c.translate(w / 1, 0);
      c.scale(-1, 1);
      c.drawImage(v, 0, 0, w, h);
      setTimeout(this.updateLocalVid, 20);
    },
    updateMediaVid(){
      var v = document.getElementById('minMedia'); 
      var canvas = document.getElementById('maxMedia');
      var c = canvas.getContext('2d');
      if(!this.fullscreen){
        var h = window.innerHeight-window.innerHeight/5;
        var w = v.videoWidth*(h/v.videoHeight);
      }
      else {
        var h = window.innerHeight - 3;
        var w = v.videoWidth*(h/v.videoHeight);
      }
      canvas.width = w;
      canvas.height = h;
      if (v.paused || v.ended) return false;
      c.drawImage(v, 0, 0, w, h);
      setTimeout(this.updateMediaVid, 20);
    },

    debug(e){
      console.log('debug:', e);
    },
    addStream() { this.$sip.vid(); },
    addDisplay() { this.$sip.display(); },

    debug(e) {
      console.log('debug: ', e)
    },

    logLineKeys(lk) {
      console.log(this.lineKeys)
      console.log('lineKeyId: ', lk.line_label)
    },
    isIncoming: it => it instanceof Invitation,
    attachMedia() {
      this.runVids();
    },
    numberFromURI(uri) {
      return uri.toString().substring(4, 10);
    },
    formatNum(num) {
      if (!num) return null;
      if (num.includes('CONF')){
        return 'Conference'
      }
      num = String(num);
      if (num.length == 10){
        num="(" + num.substring(0,3) + ") " + num.substring(3,6) + "-" + num.substring(6, 10);
      }
      return num;
    },
    updateParent() {
      this.$parent.$parent.attachMedia();
    },
  },
  watch: {
    session() {
      console.log("#### SESSION UPDATED");
      this.attachMedia();
    },
    media: function(newVal, oldVal) {
      this.attachMedia();
      console.log('media: ', [[newVal]])
    },
    localVideo() {
      this.attachMedia();
    },
  },
};
</script><style>
.PULSE {
    /* Chrome, Safari, Opera */
  -webkit-animation: PULSE 1s infinite; 

  /* Internet Explorer */
  -ms-animation: PULSE 1s infinite;

  /* Standard Syntax */
  animation: PULSE 1.25s infinite; 
}
.controls {
    width:100%;
    padding-top:7px;
    padding-left:8px;
    border:2px solid grey !important;
}
.mainDialog {
    height:400px;
    overflow-y: hidden;
}
.fullscreen {
  position:absolute;
  width:100vw;
  height:100vh;
  top:0;
  left:0;
  z-index:9999;
  background-color:black;
  overflow-y:hidden;
}
</style>